<icc-list [searchable]="true" [items]="reinforcements" [itemTemplate]="itemReinforcement" itemImgHeight="medium"
[itemWidth]="'wide'" [selected]="selectedReinforcement?.id" (select)="selectReinforcement($event)" [tabs]="null"></icc-list>

<ng-template #itemReinforcement let-item="iccListItem">
  <div class="item-imgTitleDescription">
    <p class="item-imgTitleDescription-title">{{item.name}}</p>
    @if(!hiddenPrice)
    {
      <p class="item-imgTitleDescription-price">
        {{ 'CONFIGURATOR|Cena' | translate }}:<br>
      
        <b>
          @if (item.price) {
            <span
              >{{priceMarket(item.price) | unitm:0:0:3 | currency: currency}}/<span
              [innerHTML]="2|formatUnit"></span><br></span>
          }
          @if (item.price === 0) {
            <span
              >{{ 'CONFIGURATOR|W cenie' | translate }}<br></span>
          }
          @if (!item.price && item.price !== 0) {
            <span
              >{{ 'CONFIGURATOR|Do wyceny' | translate }}<br></span>
          }
        </b>
      </p>
    }
          
        </div>
      </ng-template>
